import { exportToExcel } from "../../../Utils/ExportToExcel";

const EXPORT_COLUMNS = [
  { headerName: "הזמנה", field: "ordname" },
  { headerName: "מס לקוח", field: "custname" },
  { headerName: "שם לקוח", field: "custdes" },
  { headerName: "תאריך אספקה", field: "duedate" },
  { headerName: "תאריך הזמנה", field: "curdate" },
  { headerName: "סניף", field: "branchname" },
  { headerName: "תת חברה", field: "companyname" },
  { headerName: "לקוח מרכז", field: "mcustname" },
  { headerName: "לקוח מקבל", field: "endcust" },
  { headerName: "טלפון", field: "phone" },
  { headerName: "מקט", field: "partname" },
  { headerName: "כמות בהזמנה", field: "quant" },
  { headerName: "תאור מוצר", field: "partdes" },
  { headerName: "לטיפול", field: "neo_ownerlogin" },
  { headerName: "מלאי זמין למכירה", field: "balance" },
];

/**
 * Flatten orders with their lines for Excel export
 * Each line becomes a separate row with order details
 */
const flattenOrdersForExport = (orders) => {
  const flattenedOrders = [];

  orders.forEach((order) => {
    order.lines.forEach((line) => {
      const flattenedOrder = {
        ordname: order.ordname || "",
        custname: order.custname || "",
        custdes: order.custdes || "",
        companyname: order.companyname || "",
        branchname: order.branchname || "",
        curdate: order.curdate || "",
        phone: order.phone || "",
        neo_ownerlogin: order.neo_ownerlogin || "",
        mcustdes: order.mcustdes || "",
        mcustname: order.mcustname || "",
        endcustname: order.endcustname || "",
        endcust: order.endcustname && order.endcustdes ? `${order.endcustname} - ${order.endcustdes}` : order.endcustname || "",
        partname: line.partname || "",
        partdes: line.partdes || "",
        quant: line.quant || "",
        balance: line.balance || "",
        duedate: line.duedate || "",
      };

      flattenedOrders.push(flattenedOrder);
    });
  });

  return flattenedOrders;
};

/**
 * Export filtered orders to Excel file
 */
export const handleExportOrdersToExcel = (filteredOrders) => {
  const flattenedOrders = flattenOrdersForExport(filteredOrders);
  exportToExcel(flattenedOrders, EXPORT_COLUMNS, "filtered_orders_export");
};
